import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import { useSearchUsers } from '../../SearchUsers/SearchUsers';
import translations from '../.vocab';

import { EmptyStateIcon } from './EmptyStateIcon';

export const SearchEmptyState = () => {
  const { t } = useTranslations(translations);
  const { searchTerm } = useSearchUsers();
  return (
    <Box background="surface" paddingX="xlarge" paddingY="large" width="full">
      <Stack space="medium">
        <Box display="flex" justifyContent="center" width="full">
          <EmptyStateIcon />
        </Box>
        <Box>
          <Text align="center">
            {t('0 search results for...', { searchText: searchTerm })}
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};
